import DeviceService from 'Services/device';
import Search from 'Mixins/search';
import L from 'leaflet';
import moment from 'moment';
import Vue from 'vue';
import { mask } from 'vue-the-mask';
import _ from 'lodash';

export default {
	name: 'device-details-modal',
	mixins: [Search],
	directives: {
		mask
	},
	created() {
		this.currentFilter = this.$route.params.filter;
		this.isLoading = true;
		DeviceService.getDeviceInfo(this.$route.params.publicID).then(response => {
			var device = response.data;
			this.oldDevice = device;
			this.newDevice = _.cloneDeep(device, true);
			DeviceService.getDevicePackages(device.PublicID)
				.then(packagesResponse => {
					this.packages = packagesResponse.data.apps;
				})
				.catch(() => {
					this.getPackagesError = true;
				})
				.finally(() => {
					this.isLoading = false;
				});
			if (device.DeviceNick) {
				this.link = window.location.origin + '/' + device.DeviceNick;
			} else {
				this.link = window.location.origin + '/mgm?serial=' + device.Serial;
			}
		});
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			isLoading: false,
			isVisible: false,
			getPackagesError: false,
			tabs: 'apps',
			deviceNickMask: {
				mask: 'nnnnnnnnnnnnnnnnnnnnnnnnnnnnnn',
				tokens: {
					n: {
						pattern: /[0-9a-zA-Z]/,
						transform: v => v.toLocaleLowerCase()
					}
				}
			},
			isDeviceNickBeingEdited: false,
			oldDevice: {},
			newDevice: {},
			packages: {},
			link: '',
			errorSnack: {
				visible: false,
				message: '',
				color: 'red',
				timeout: 6000
			},
			modal: {
				breakpoint: 680
			}
		};
	},
	computed: {
		device() {
			return this.isDeviceNickBeingEdited ? this.newDevice : this.oldDevice;
		},
		sortedPackages() {
			return _.sortBy(this.packages, function(device) {
				return device.appName.toLowerCase();
			});
		},
		location() {
			const location = this.device.Location.split(',');
			return {
				lat: location[0],
				long: location[1]
			};
		},
		isModalSizeLowerThenBreakpoint() {
			return this.windowSize.width <= this.modal.breakpoint;
		}
	},
	methods: {
		editDeviceNick() {
			this.isDeviceNickBeingEdited = true;

			Vue.nextTick(() => {
				// wait for the input to render
				this.$refs.deviceNickInput.focus();
				// we use `element.focus()` because the `autofocus` attribute
				// is not reliable in this case
			});
		},
		discardDeviceNick() {
			this.isDeviceNickBeingEdited = false;
			this.newDevice.DeviceNick = this.oldDevice.DeviceNick;
		},
		saveDeviceNick() {
			DeviceService.saveDevice(this.oldDevice.PublicID, this.newDevice)
				.then(response => {
					this.$store.dispatch('updateDevices', {
						search: this.isBackendSearchUsed ? this.currentFilter : '',
						force: true
					});
					this.back();
				})
				.catch(error => {
					if (error.response.status >= 400 && error.response.status < 500) {
						this.errorSnack.message = 'This nick is already taken';
					} else {
						this.errorSnack.message = 'Rename failed, please try again';
					}
					this.errorSnack.visible = true;
					this.discardDeviceNick();
				});
		},
		deleteDevice() {
			DeviceService.deleteDevice(this.oldDevice.PublicID).then(response => {
				this.$store.dispatch('updateDevices', {
					search: this.isBackendSearchUsed ? this.currentFilter : '',
					force: true
				});
				this.back();
			});
		},
		onShowOnMap() {
			if (this.device.Location && this.tabs === "gps") {
				const vue = this;
				setTimeout(function() {
					if (vue.map ===undefined) {
						vue.map = L.map('map', {
							dragging: false,
							scrollWheelZoom: false,
							attributionControl: false
						}).setView(vue.device.Location.split(','), 8);
						L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { detectRetina: true }).addTo(vue.map);
						L.marker([vue.location.lat, vue.location.long]).addTo(vue.map);
					}
					DeviceService.getLocation(vue.location.lat, vue.location.long).then(response => {
						if (response.data.result !== undefined) {
							vue.device.Address = response.data.results[0].formatted_address;
						}
					});
				}, 400);
			}
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.go(-1);
			}
		}
	},
	filters: {
		status(status) {
			return status ? `Online` : `Pending`;
		},
		lastActivity(datetime) {
			return datetime ? moment.unix(datetime).format('LLL') : ``;
		},
		capitalize(string) {
			return (string || '').replace(/\b\w/g, l => l.toUpperCase());
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/device-details-modal/script.js